import React from "react";

const PhoneIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.19325 9.68873C-0.000134643 15.4017 4.49832 22.2025 10.1479 27.852C15.7976 33.5017 22.5982 38.0002 28.3112 36.8067C33.0097 35.8253 35.4083 33.3225 36.7583 31.19C37.2241 30.454 36.9889 29.4989 36.2908 28.9782L29.6798 24.0469C28.967 23.5152 27.9717 23.5872 27.343 24.2161L23.8339 27.7251C23.8339 27.7251 20.423 26.6163 15.9032 22.0967C11.3837 17.577 10.2749 14.1661 10.2749 14.1661L13.784 10.657C14.4128 10.0282 14.4849 9.0331 13.9531 8.32022L9.02184 1.70913C8.50112 1.01105 7.54594 0.775932 6.81007 1.24172C4.67744 2.59164 2.17469 4.99028 1.19325 9.68873Z"
        stroke="#3F3F3F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PhoneIcon;
